import { AsyncPipe, NgTemplateOutlet } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { SidebarLayoutModule } from '../../../shared/ui-components/sidebar-layout/sidebar-layout.module';
import { IconModule } from '../../../shared/ui-components/icon/icon.module';
import { RouterService } from '../../router/services/router.service';
import { ImageResolutionPipe } from '../../media/pipes/image-resolution.pipe';
import { AuthService } from '../../auth/services/auth.service';
import { UserService } from '../../user/services/user.service';
import { NarrowSidebarSearchDirective } from '../../../shared/ui-components/sidebar-layout/directives/narrow-sidebar-search.directive';
import { AutocompleteModule } from '../../../shared/ui-components/autocomplete/autocomplete.module';
import { MainNavigationSearchComponent } from '../main-navigation-search/main-navigation-search.component';
import { NamePipe } from '../../../shared/pipes/name.pipe';

@Component({
  selector: 'app-main-navigation',
  imports: [
    AsyncPipe,
    NgTemplateOutlet,
    RouterLink,
    SidebarLayoutModule,
    IconModule,
    ImageResolutionPipe,
    NarrowSidebarSearchDirective,
    AutocompleteModule,
    MainNavigationSearchComponent,
    NamePipe,
  ],
  templateUrl: './main-navigation.component.html',
})
export class MainNavigationComponent {
  // DI
  private readonly authSvc = inject(AuthService);
  private readonly userSvc = inject(UserService);
  private readonly routerSvc = inject(RouterService);

  // Streams
  readonly claims$ = this.authSvc.claims$;
  readonly emailVerified$ = this.authSvc.emailVerified$;
  readonly currentUser$ = this.userSvc.currentUser$;

  // Template API
  readonly homeUrl$ = this.routerSvc.homeUrl$;

  // TODO for testing only -> remove
  readonly temp$ = this.authSvc.currentAuthUser$.subscribe();
}
